module.exports = __webpack_public_path__ + "img/des_pintu_3.eade0df7.jpg";